<div class="login-container">
  <mat-card class="login-card">
    <!-- <mat-card-header>
        <div class="login-header-container">
          <img class="login-header" src="assets/images/app-title-logo.png">
        </div>
      </mat-card-header> -->
    <!-- <div class="login-overlay"></div> -->
    <mat-card-content>
      <div class="splash-info-container">
        <img src="assets/images/eps-login.png" class="login-splash">
        <div class="splash-text">
          <p class="company-name">ST PIERRES</p>
          <p class="system-name">ENTERPRISE POS SYSTEM (EPS)</p>
        </div>
      </div>

      <div class="login-form-container">
        <div class="login-title">
          LOGIN
        </div>
        <form class="login-form" [formGroup]="loginForm" (ngSubmit)="proceedUserLogin()">

          <div class="user-cred">

            <mat-form-field class="user_type">
              <mat-label>Login To </mat-label>
              <mat-select formControlName="user_type" [(ngModel)]="selectedUser" (ngModelChange)="onUserTypeChange()">

                <mat-option value="HQ"> HQ </mat-option>
                <mat-option value="SHOP">SHOP</mat-option>
                <mat-option value="AREA_MANAGER">AREA MANAGER</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="" *ngIf="isShopVisible">
              <mat-label>Shop Name</mat-label>
              <input type="text" matInput formControlName="shop_id" [matAutocomplete]="shopAuto" (input)="filterShops()"
                (focus)="filterShops()" [value]="displayShopName(loginForm.get('shop_id')?.value)" autocomplete="off">
              <button *ngIf="loginForm.get('shop_id')?.value" matSuffix mat-icon-button aria-label="Clear" type="button"
                (click)="clearShop()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete #shopAuto="matAutocomplete" [displayWith]="displayShopName.bind(this)">
                <mat-option *ngFor="let shop of filteredShops" [value]="shop">
                  {{ shop.name }}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="loginForm.get('shop_id')?.hasError('invalidShop')">
                Please select a valid shop from the list.
              </mat-error>
            </mat-form-field>

            <mat-form-field class="user-name">
              <mat-label>Username</mat-label>
              <input matInput formControlName="user_id">
            </mat-form-field>
            <mat-form-field class="password">
              <mat-label>Password</mat-label>
              <input matInput type="password" formControlName="password">
            </mat-form-field>
          </div>
          <div>
            <button mat-raised-button color="primary" type="submit">Login</button>
          </div>

        </form>
        <div class="version-info">
          <span>Ver:{{version}}</span>
          <span>Build:{{buildNo}}</span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

</div>